import React, { useRef, useEffect, useState } from "react";
import useSelectVMinitialize from "./useSpatialSelectVMinitialize";
import { Button, IconButton, InputLabel, Paper, Stack, Typography } from "@mui/material";
import GeometryButton from "../../../../components/geometry-buttons/GeometryButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Input from '@mui/material/Input';
import CloseIcon from '@mui/icons-material/Close';

const SpatialSelectWidget = ({ activeWidget, view, attributeObject,showWidget,setShowWidget, setDisable }) => {
  const [visible, setVisible] = useState(false);
  const spatialSelectWidgetDiv = useRef(null);
  const pointGeometryButton = useRef(null)
  const lineGeometryButton = useRef(null)
  const polygonGeometryButton = useRef(null)
  const rectangleGeometryButton = useRef(null)
  const circleGeometryButton = useRef(null)
  const clearGeometryButton = useRef(null)
  const closeSpatialContainerButton = useRef(null)
  // const [showQueryBlock,setShowQueryBlock]=useState(false)
  const [bufferValue, setBufferValue] = useState(0)

  useEffect(() => {
    if (activeWidget === "spatial-select") {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]);


  useSelectVMinitialize({
    attributeObject: attributeObject,
    selectDiv: spatialSelectWidgetDiv,
    pointDivBtnClk: pointGeometryButton,//"point-geometry-button",
    lineDivBtnClk: lineGeometryButton,//"line-geometry-button",
    polygonDivBtnClk: polygonGeometryButton,//"polygon-geometry-button",
    rectangleDivBtnClk: rectangleGeometryButton, //"extent-geometry-button", 
    circleDivBtnClk: circleGeometryButton,
    clearGeometryBtnClk: clearGeometryButton,//"clearGeometry",
    closeSpatialContainerBtnClk:closeSpatialContainerButton,
    view: view,
    bufferValue: bufferValue,
    setBufferValue:setBufferValue,
    setShowQueryBlock:setShowWidget
  });

  let style = { display: "initial" };
  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }

  return (
    <>
      <div ref={spatialSelectWidgetDiv} id="spatialSelectWidget" style={{marginTop:'20px'}}>
        
        <Paper sx={{position:'relative',p:2,display:!showWidget?'none':'block'}}>
        <Button
        ref={closeSpatialContainerButton}
      sx={{position:'absolute', top:0, right:0}}
      >
          <CloseIcon color='warning'/>
      </Button>
          <Stack direction="column" justifyContent={'space-evenly'} sx={{p:2}} alignItems={'flex-start'} spacing={2}>
        <Stack direction="row" justifyContent={'space-evenly'} sx={{flexWrap:"wrap"}}>
        <GeometryButton
              value="point"
              title="query by point intersect"
              id="point-query"
              ref={pointGeometryButton}
            />
            <GeometryButton
              value="polyline"
              title="query by line intersect"
              id="line-query"
              ref={lineGeometryButton}
            />
            <GeometryButton
              value="polygon"
              title="query by polygon intersect"
              id="polygon-query"
              ref={polygonGeometryButton}
            />
            <GeometryButton
              value="circle"
              title="query by cicle intersect"
              id="circle-query"
              ref={circleGeometryButton}
            />
            <GeometryButton
              value="rectangle"
              title="query by rectangle intersect"
              id="rectangle-query"
              ref={rectangleGeometryButton}
            />
            <IconButton
              title="clear selected"
              ref={clearGeometryButton}
            >
              <DeleteIcon />
            </IconButton>
          </Stack>
          <InputLabel id='spatial-select-bufferInputLabel' htmlFor="bufferInput">Add buffer in feet</InputLabel>
          <Stack direction='row'>
          <Input id="bufferInput" value={bufferValue} name="bufferInput" type="number" placeholder="Buffer (ft)" inputProps={{min:'0'}} onChange={(e: any) => {
              setBufferValue(e.target.value)
            }}></Input>
            <Typography> ft</Typography>
            </Stack>
            </Stack>
            </Paper>
        </div>
        <br />
    </>
  );
};



export default SpatialSelectWidget